import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import PageLoader from "./../../../../assets/loading/pageLoad1.gif"

const EditVlccPurchase = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading]     = useState(false)
  const [pageLoad, setPageLoad]   = useState(true)
  const [purchase, setPurchase]   = useState({})
  const [companies, setCompanies] = useState([])
  const [plants, setPlants]       = useState([])
  const [chillings, setChillings] = useState([])
  const [routes, setRoutes]       = useState([])
  const [collections, setCollections] = useState([])
  const [producers, setProducers] = useState([])
  const [entryMode, setEntryMode] = useState("")

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    try {
      const [recResp, chilResp, rouResp, ccResp, proResp, cosResp, pltResp] = await Promise.all([
        api.get("vlcc-purchase/" + id),
        api.get("centers?per_page=500"),
        api.get("routes?per_page=500"),
        api.get("collection-centers?per_page=500"),
        api.get("producers?per_page=500"),
        api.get("companies"),
        api.get("plants"),
      ])

      const record = recResp.data.data[0] || {}
      setPurchase(record)
      setEntryMode(String(record.entryMode || ""))

      const extract = resp => { const d = resp.data?.data; return Array.isArray(d) ? d : d?.data || [] }
      setChillings(extract(chilResp))
      setRoutes(extract(rouResp))
      setCollections(extract(ccResp))
      setProducers(extract(proResp))
      setCompanies(extract(cosResp))
      setPlants(extract(pltResp))
    } catch (error) { console.error("Failed to load purchase data:", error) }
    setPageLoad(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    setSubmitted(false)
    try {
      const response = await api.put("update-vlcc-purchase/" + id, values)
      if (response.data.success === true) {
        setSubmitted(true)
        setTimeout(() => setSubmitted(false), 3000)
      }
    } catch (error) {
      console.error("Update failed:", error)
    }
    setLoading(false)
  }

  if (pageLoad) {
    return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit VLCC Purchase</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/vlcc-purchases" className="dashBtn">
                <i className="fas fa-chevron-left"></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => handleValidSubmit(e, v)}
          >
            {/* Location Section */}
            <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px" }}>
              <i className="fas fa-map-marker-alt"></i> Location Details
            </h6>
            <Row>
              {/* Company — only if >1 */}
              {companies.length > 1 && (
                <Col md={3}>
                  <div className="mb-3">
                    <label className="form-label">Company</label>
                    <select className="form-control" defaultValue={String(purchase.company || "")}>
                      <option value="">Select Company</option>
                      {companies.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}
                    </select>
                  </div>
                </Col>
              )}
              {/* Plant */}
              <Col md={companies.length > 1 ? 3 : 6}>
                <div className="mb-3">
                  <AvField type="select" name="plant" label="Plant"
                    value={String(purchase.plant || "")}>
                    <option value="">Select Plant</option>
                    {plants.map((p, i) => <option key={i} value={String(p.id)}>{p.name}</option>)}
                  </AvField>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField type="select" name="chillingCenter" label="Chilling Center"
                    required value={String(purchase.chillingCenter || "")}>
                    <option value="">Select Chilling Center</option>
                    {chillings.map((c, i) => (
                      <option key={i} value={String(c.id)}>{c.name}</option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField type="select" name="route" value={String(purchase.route || "")}
                    label="Route" required>
                    <option value="">Select Route</option>
                    {routes.map((r, i) => (
                      <option key={i} value={String(r.id)}>{r.routeName}</option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField type="select" name="collectionCenter" value={String(purchase.collectionCenter || "")}
                    label="Collection Center" required>
                    <option value="">Select Collection Center</option>
                    {collections.map((c, i) => (
                      <option key={i} value={String(c.id)}>{c.centerName}</option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField type="select" name="producer" value={String(purchase.producer || "")}
                    label="Producer" required>
                    <option value="">Select Producer</option>
                    {producers.map((p, i) => (
                      <option key={i} value={String(p.id)}>{p.producerName || p.name} {p.producerCode ? `(${p.producerCode})` : ""}</option>
                    ))}
                  </AvField>
                </div>
              </Col>
            </Row>

            {/* Purchase Info Section */}
            <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "8px" }}>
              <i className="fas fa-shopping-cart"></i> Purchase Details
            </h6>
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="purchaseDate" label="Purchase Date"
                    value={purchase.purchaseDate} className="form-control" type="date" required />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvRadioGroup inline name="shift" value={String(purchase.shift)}
                    label="Shift" required errorMessage="Pick one!">
                    <AvRadio label="AM (Morning)" value="0" />
                    <AvRadio label="PM (Evening)" value="1" />
                  </AvRadioGroup>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="serialNo" label="Serial Number" value={purchase.serialNo}
                    className="form-control" type="text" />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvRadioGroup inline name="milkType" label="Milk Type"
                    value={String(purchase.milkType)} required errorMessage="Pick one!">
                    <AvRadio label="Cow" value="1" />
                    <AvRadio label="Buffalo" value="2" />
                    <AvRadio label="Common" value="3" />
                  </AvRadioGroup>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="qtyUnit" label="Quantity Unit" type="select"
                    className="form-control" value={purchase.qtyUnit}>
                    <option value="Ltrs">Liters</option>
                    <option value="KG">Kilograms</option>
                  </AvField>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="purchaseTime" label="Purchase Time" value={purchase.purchaseTime}
                    className="form-control" type="time" />
                </div>
              </Col>
            </Row>

            {/* Quality Section */}
            <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "8px" }}>
              <i className="fas fa-flask"></i> Quantity & Quality Parameters
            </h6>
            <Row>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="qtyLtrs" label="Quantity (Liters)" value={purchase.qtyLtrs}
                    className="form-control" type="number" step="0.01" required
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="qtyKg" label="Quantity (KG)" value={purchase.qtyKg}
                    className="form-control" type="number" step="0.01"
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="purchaseFat" label="FAT" value={purchase.purchaseFat}
                    className="form-control" type="number" step="0.01" required
                    validate={{ min: { value: 0 }, max: { value: 15 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvRadioGroup inline name="entryMode" value={String(purchase.entryMode)}
                    label="Entry Mode" required errorMessage="Pick one!"
                    onChange={e => setEntryMode(e.target.value)}>
                    <AvRadio label="SNF" value="1" />
                    <AvRadio label="CLR" value="2" />
                  </AvRadioGroup>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="purchaseSnf" label="SNF" value={purchase.purchaseSnf}
                    className="form-control" type="number" step="0.01" required
                    readOnly={entryMode === "2"}
                    validate={{ min: { value: 0 }, max: { value: 15 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="purchaseClr" label="CLR" value={purchase.purchaseClr}
                    className="form-control" type="number" step="0.01" required
                    readOnly={entryMode === "1"}
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="waterPercent" label="Water %" value={purchase.waterPercent}
                    className="form-control" type="number" step="0.01"
                    validate={{ min: { value: 0 }, max: { value: 100 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="purchaseCans" label="Purchase Cans" value={purchase.purchaseCans}
                    className="form-control" type="number" step="1"
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField name="temperature" label="Temperature" value={purchase.temperature}
                    className="form-control" type="number" step="0.1" />
                </div>
              </Col>
            </Row>

            {/* Pricing Section */}
            <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "8px" }}>
              <i className="fas fa-rupee-sign"></i> Pricing Details
            </h6>
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="ratePerLtr" label="Rate Per Liter (₹)" value={purchase.ratePerLtr}
                    className="form-control" type="number" step="0.01"
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="ratePerKg" label="Rate Per KG (₹)" value={purchase.ratePerKg}
                    className="form-control" type="number" step="0.01"
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField name="incentive" label="Incentive (₹)" value={purchase.incentive}
                    className="form-control" type="number" step="0.01"
                    validate={{ min: { value: 0 } }} />
                </div>
              </Col>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>VLCC Purchase Updated Successfully!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light"
                  type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span><i className="fas fa-save"></i> Update Purchase</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditVlccPurchase
